import { render, staticRenderFns } from "./DeliveryAddresses.vue?vue&type=template&id=5c668b68"
import script from "./DeliveryAddresses.vue?vue&type=script&lang=js"
export * from "./DeliveryAddresses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c668b68')) {
      api.createRecord('5c668b68', component.options)
    } else {
      api.reload('5c668b68', component.options)
    }
    module.hot.accept("./DeliveryAddresses.vue?vue&type=template&id=5c668b68", function () {
      api.rerender('5c668b68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/components/DeliveryAddresses.vue"
export default component.exports